import { render, staticRenderFns } from "./WrittingBox.vue?vue&type=template&id=4c9f74f6&scoped=true&"
import script from "./WrittingBox.vue?vue&type=script&lang=js&"
export * from "./WrittingBox.vue?vue&type=script&lang=js&"
import style0 from "./WrittingBox.vue?vue&type=style&index=0&id=4c9f74f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9f74f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VIcon,VProgressCircular,VTextarea})
